export default "__VITE_ASSET__CoIeYQoJ__"